import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=1d860bb4&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d860bb4",
  null
  
)

export default component.exports